import React from "react";
import ReactDOM from "react-dom/client";
import { getTenantConfig } from "./tenant/getTenantFromHost";
import { applyTheme } from "./tenant/applyTheme";
import { applyMeta } from "./tenant/applyMeta";
import { initI18n } from "./i18n/config";
import App from "./App";

// ---------------------------------------------------------------------------
// Bootstrap: resolve tenant → apply theme → apply meta → init i18n → render
// ---------------------------------------------------------------------------
const tenantConfig = getTenantConfig();
applyTheme(tenantConfig);
applyMeta(tenantConfig);
initI18n(tenantConfig);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App tenantConfig={tenantConfig} />
  </React.StrictMode>
);
